"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _crmApi = require("@ys/crm-api");
var _crypto = _interopRequireDefault(require("@ys/utils/lib/crypto"));
var _antDesignVue = require("ant-design-vue");
var _axios = require("axios");
var _defaultSettings = require("@/config/defaultSettings");
var _router = _interopRequireDefault(require("@/router"));
var _store = _interopRequireDefault(require("@/store"));
_crmApi.client.setConfig({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000,
  responseType: 'json',
  throwOnError: true
});
const SUCCESS_CODE = '00000';
const needLogin = (status, code) => {
  return status === 401 || ['A0322', 'A0230', 'A0301'].includes(code);
};
_crmApi.client.instance.interceptors.request.use(request => {
  const {
    accessToken,
    tenantInfo: {
      tenantId
    }
  } = _store.default.getters;
  request.headers.set('Authorization', `Basic ${_crypto.default.base64Encode(`${_defaultSettings.clientId}:${_defaultSettings.clientSecret}`)}`).set('tenantId', tenantId).set('accessToken', accessToken);
  return request;
});
_crmApi.client.instance.interceptors.response.use(response => {
  const {
    config,
    status,
    data
  } = response;
  if (config.responseType === 'blob') {
    downloadFile(response);
    return response;
  }
  if (status === 200 && data.code === SUCCESS_CODE) {
    return response;
  }
  const loginPath = '/user/login';
  const isLoginPath = _router.default.currentRoute.path === loginPath;
  if (needLogin(status, data.code) && !isLoginPath) {
    _store.default.dispatch('ALogout', true);
    throw '重新登录';
  }
  const errorMessage = data.msg ?? '请求失败，请重试';
  _antDesignVue.message.warn({
    content: errorMessage
  });
  const error = new _axios.AxiosError(errorMessage, data.code ?? status, config, config, response);
  return Promise.reject(error);
}, error => {
  const message = error?.response?.data?.msg ?? error.message ?? '请求失败，请重试';
  _antDesignVue.message.warn({
    content: message
  });
  throw error;
});
function downloadFile({
  headers,
  data
}) {
  const fileName = decodeURIComponent(headers['content-disposition']?.split('=')[1]);
  const blob = new Blob([data], {
    type: 'application/x-download'
  });
  const link = document.createElement('a');
  link.download = fileName;
  link.style.display = 'none';
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}